import { useState } from 'react';
import { db } from '../../../firebase/config.js';
import { useFirestore } from '../../../firebase/useFirestore';
import {
    HOURLY_RATE_FIELDS,
    parseHourlyRate,
    readHourlyRates,
    formatHourlyRate,
} from '../../../helpers/adressHelpers/hourlyRates';

/** @type {Array<{key: 'uitvoering'|'advies', label: string}>} */
const RATES = [
    { key: 'uitvoering', label: 'Uurtarief uitvoering' },
    { key: 'advies', label: 'Uurtarief advies' },
];

/**
 * Instellingen → Agenda en afspraken → 'Uurtarieven', direct onder 'Soorten
 * afspraak': de twee tarieven waarmee de
 * SiSa/SPUK-verantwoording uren omrekent naar besteding. Welke afspraken als
 * uitvoering of advies tellen, kies je per soort bij 'Soorten afspraak'.
 *
 * Opslaan bij het verlaten van het veld; een leeg veld is 'niet ingesteld',
 * niet €0.
 * AI-CONTEXT: See docs/features/huishouden-vaste-gegevens.md (T18)
 *
 * @returns {JSX.Element}
 */
const HourlyRatesConfig = () => {
    const compagny = useFirestore('CompagnyMeta');
    const [messages, setMessages] = useState(/** @type {Record<string, string>} */ ({}));

    const comp = Array.isArray(compagny) ? compagny[0] : undefined;
    const rates = readHourlyRates(comp);

    /** @param {string} key @param {string} message */
    const setMessage = (key, message) => setMessages((prev) => ({ ...prev, [key]: message }));

    /**
     * @param {'uitvoering'|'advies'} key
     * @param {string} raw - Wat er in het veld staat
     */
    const blurHandler = (key, raw) => {
        const result = parseHourlyRate(raw);
        if ('error' in result) {
            setMessage(key, result.error);
            return;
        }
        setMessage(key, '');
        if (result.value === rates[key]) return;
        db.collection('CompagnyMeta')
            .doc(comp.docid)
            .update({ [HOURLY_RATE_FIELDS[key]]: result.value })
            .catch(() => setMessage(key, 'Opslaan is niet gelukt. Probeer het opnieuw.'));
    };

    return (
        <div className="dashboard-container">
            <h2>Uurtarieven</h2>
            <p>
                Hiermee rekent de SiSa/SPUK-verantwoording de uren van afspraken om naar een bedrag. Bij 'Soorten
                afspraak' kies je per soort of die telt als uitvoering of als advies.
            </p>
            {!comp ? (
                <p className="status-config-loading">Instellingen worden geladen…</p>
            ) : (
                RATES.map(({ key, label }) => (
                    <div key={key} className="settings-general-module-settings-item-container">
                        <p>{label} (€)</p>
                        <div>
                            {/* Ongestuurd, met de opgeslagen waarde in de key: na het
                                opslaan haakt het veld opnieuw aan met de nette vorm,
                                bij een fout blijft de getypte tekst staan. */}
                            <input
                                key={`${key}:${rates[key]}`}
                                type="text"
                                inputMode="decimal"
                                defaultValue={formatHourlyRate(rates[key])}
                                onBlur={(e) => blurHandler(key, e.target.value)}
                                aria-label={label}
                            />
                            {messages[key] && <p className="fixed-data-message" role="alert">{messages[key]}</p>}
                        </div>
                    </div>
                ))
            )}
        </div>
    );
};

export default HourlyRatesConfig;
